import React from 'react';
import { AssetBlockProps } from '../../pages/AssetApp';
import ProfileAssetHeading from './ProfileAssetHeading';

const TopEmployers: React.FC<AssetBlockProps> = ({ asset }) => {
  return (
    <div>
      <ProfileAssetHeading heading={asset.topEmployers?.heading} />
      <div style={{ padding: 24 }}>
        <img style={{ width: '100%' }} src={asset.topEmployers?.employersImage.file.url} />
      </div>
    </div>
  );
};

export default TopEmployers;
